import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {observable} from "mobx";
import FirebaseMyAccountFunctionsService
    from "../../../../services/firebase/functions/FirebaseMyAccountFunctionsService";
import { IUpgradePlanRequest} from "../../../../../../shared/src/functions/membersApi/types/IPlanRequests";
import { UpgradeState } from "../UpgradeState";
import { MyAccountStores } from "src/scenes/MyAccount/state/mobx";

const accountStore = MyAccountStores.accountUserStore;

export class UpgradeFormStore extends ApiCallObservable {
    @observable public formInput: any = {};
    @observable public navigationController: any = {};
    @observable private _currentScreen: UpgradeState = UpgradeState.verification;
    @observable private _isFormFinish: boolean = false;

    get currentScreen() {
        return this._currentScreen;
    };

    get allowFinishForm() {
        return this._isFormFinish;
    };

    public updateFinishForm = (value: boolean) => {
        this._isFormFinish = value;
    };

    public updateScreen = (screen: UpgradeState) => {
        this._currentScreen = screen;
    };

    public updateLease = (pdfFile: string | ArrayBuffer | null) => {
        this.formInput = {
            upgrade: {
                upgradePdfFile: pdfFile
            }
        }
        this.updateFinishForm(true)
    };

    public initState = () => {
        this.updateScreen(UpgradeState.verification);
        this.updateFinishForm(false)
    }
    public async upgradePlan() {
        try {
            this.setSending();
            const upgradeParams: IUpgradePlanRequest = {
                planId : accountStore.selectedPlan!.id,
                membershipAgreementData : this.formInput.upgrade.upgradePdfFile
            };
            const response = await FirebaseMyAccountFunctionsService.upgradePlan(upgradeParams);
            if (response.ok && response.data) {
                this.setSuccessfulResponse(response.data);
                this.updateScreen(UpgradeState.finish);
            } else {
                console.log(response);
                this.setError("Failed fetching summary");
            }
            this.updateScreen(UpgradeState.finish);
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/UpgradeStore.ts